module.exports = __webpack_public_path__ + "static/media/arrow-down.b5e718cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/arrow-down.svg
// module id = 239
// module chunks = 0